import SectionTitle from "@/components/ui/section-title";
import DesktopTable from "./desktopTable";
import MobTable from "./mobTable";
import CtaBtn from "@/components/ui/cta-btn";

const Packing_Details = ({ packingDetails }) => {
  return (
    <section className="bg-[#F6F6F6] py-5 lg:py-[2.5vw]">
      <div className="container">
        <SectionTitle customClass={"text-center"} title={"Packing Details"} />
        <div>
          <DesktopTable packingDetails={packingDetails} />
        </div>
        <div>
          <MobTable packingDetails={packingDetails} />
        </div>
        <div>
          <CtaBtn
            link={"/tiles-calculator"}
            name={"Tiles Calculator"}
            customClass={"mx-auto mt-7"}
          />
        </div>
      </div>
    </section>
  );
};

export default Packing_Details;
